import React from 'react';
import { Translate } from '@pegasus/translation';
import { Text, Preset } from '@lux/text/tw';

interface SeeAllCardProps {
    onClick?: () => void;
    href: string;
}

export const SeeAllCard: React.FC<SeeAllCardProps> = ({ onClick, href }) => {
    const seeAllCardCarouselItemStyles =
        'relative border border-function-20 h-full w-full flex flex-col justify-center items-center cursor-pointer text-center bg-transparent px-6 py-5 hover:bg-function-5 hover:border-function-20';
    const handleClick = (event: React.SyntheticEvent) => {
        event.stopPropagation();
        onClick?.();
    };

    return (
        <a onClick={handleClick} href={href} className={seeAllCardCarouselItemStyles} type="button">
            <Text preset={Preset.M} bold underline>
                <Translate message="discoverMore" />
            </Text>
        </a>
    );
};
